import { Point } from 'paper'

export const shapesLayout1 = [
  {
    shape: 'droplet',
    position: new Point(96, 10),
    scale: 1.05,
    rotate: 230,
    color: 'red',
    overlay: {
      shape: 'overlay',
      translate: new Point(-20, 80)
    }
  },
  {
    inset: 'green-chili',
    position: new Point(98, 17),
    scale: 0.4,
    rotate: -40
  },
  {
    shape: 'droplet',
    position: new Point(5, 12),
    scale: 3,
    rotate: -58,
    color: 'blue',
    overlay: {
      shape: 'overlay',
      translate: new Point(100, -300)
    }
  },
  {
    shape: 'blobby',
    position: new Point(0, 15),
    scale: 1.19,
    color: 'blueDark'
  },
  {
    inset: 'star-anise',
    position: new Point(5, 26),
    scale: 0.3,
    rotate: 10
  },
  {
    shape: 'golf_club',
    position: new Point(85, 30),
    color: 'yellow',
    rotate: -73,
    scale: 1.3,
    overlay: {
      shape: 'overlay',
      translate: new Point(2, 400),
      scale: 1.2
    }
  },
  {
    shape: 'blobby',
    position: new Point(4, 45),
    color: 'red',
    scale: 1.8,
    overlay: {
      shape: 'overlay',
      translate: new Point(-40, 200),
      scale: 1.2
    }
  },
  {
    inset: 'cardamom',
    position: new Point(6, 55),
    scale: 0.7,
    rotate: 20
  },
  {
    inset: 'basil',
    position: new Point(97, 64),
    scale: 0.6,
    rotate: 0
  },
  {
    shape: 'tilde',
    position: new Point(82, 57),
    color: 'purple',
    rotate: -31,
    scale: 0.5
  },
  {
    shape: 'droplet',
    position: new Point(95, 76),
    color: 'skinTone',
    scale: 2.7,
    rotate: 70,
    overlay: {
      shape: 'overlay',
      translate: new Point(-40, -200),
      scale: 1
    }
  },
  {
    inset: 'coffee-3',
    position: new Point(97, 93),
    scale: 0.5,
    rotate: 0
  },
  {
    shape: 'leaf',
    position: new Point(2, 92),
    color: 'green',
    scale: 1,
    rotate: -42,
    overlay: {
      shape: 'overlay',
      translate: new Point(24, 0),
      scale: 1,
      rotate: 90
    }
  }
]
